import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

import ContentManagementProvider from './ContentManagementProvider'
import ContentManagementTable from './components/ContentManagementTable'
import Highlights from './components/Highlights'

const useStyles = makeStyles((theme) => ({
  contentRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3, 0),
  },
}))

type ContentManagementProps = {
  canManageContent: boolean
}
export default function ContentManagement({ canManageContent }: ContentManagementProps) {
  const classes = useStyles()
  return (
    <ContentManagementProvider>
      <Box className={classes.contentRoot}>
        <ContentManagementTable canManageContent={canManageContent} />
        <Highlights canManageContent={canManageContent} />
      </Box>
    </ContentManagementProvider>
  )
}
